import * as React from "react";
const SvgConfluence = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  fill: "#1868DB",
  clipPath: "url(#Confluence_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.798 17.268c-.228.351-.484.758-.7 1.083-.194.31-.09.71.234.9l4.55 2.65c.16.093.352.123.535.08a.7.7 0 0 0 .435-.305c.182-.288.417-.662.672-1.062 1.803-2.815 3.615-2.47 6.885-.994l4.513 2.03a.74.74 0 0 0 .544.023.7.7 0 0 0 .397-.354l2.167-4.636a.65.65 0 0 0-.35-.868 562 562 0 0 1-4.55-2.047c-6.134-2.819-11.345-2.636-15.332 3.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.202 6.746c.228-.351.484-.758.7-1.083a.643.643 0 0 0-.234-.9l-4.55-2.65a.73.73 0 0 0-.55-.096.7.7 0 0 0-.448.315c-.182.288-.417.662-.672 1.063-1.803 2.815-3.616 2.47-6.886.993l-4.498-2.02a.74.74 0 0 0-.544-.022.7.7 0 0 0-.397.353L1.956 7.336a.65.65 0 0 0 .35.868c.952.424 2.845 1.268 4.55 2.047 6.147 2.815 11.359 2.626 15.346-3.504z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Confluence_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1 2h22v20H1z"
}))));
export default SvgConfluence;
//# sourceMappingURL=Confluence.js.map